import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { SettingsModule } from '../models/settings-module.model';

@Injectable({ providedIn: 'root' })
export class SettingsModuleService extends AbstractService<SettingsModule> {

  getURLBase(): string {
    return '/settings-module';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: SettingsModule): void {
    delete obj?._id;
  }

  preUpdate(obj: SettingsModule): void {
  }

  getByChannel(idChannel: string): Observable<SettingsModule> {
    return super.get(`/find/channel/${idChannel}`);
  }

  getByCompany(idCompany: string): Observable<Array<SettingsModule>> {
    return super.get(`/find/company/${idCompany}`);
  }

  uploadCopilotPlaybook(file: File): Observable<{ url: string; text: string; filename?: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return super.post('/copilot/upload-playbook', formData);
  }

}
